import React, { useEffect, useState } from 'react';
const headlines = ['Wie gewinnen wir Bewerber und führen „knackigere" Interviews?', 'Wie treffen wir bessere Besetzungsentscheidungen?'];
export const InterviewtrainingPage: React.FC = () => {
  const [currentHeadline, setCurrentHeadline] = useState(0);
  const [fadeState, setFadeState] = useState<'visible' | 'fading'>('visible');
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeState('fading');
      setTimeout(() => {
        setCurrentHeadline(prev => (prev + 1) % headlines.length);
        setFadeState('visible');
      }, 500);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <>
      <section className="w-full bg-white pt-16 pb-0 px-6 md:px-12 lg:px-20" data-id="element-390">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-391">
          <div data-id="element-392">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-6 transition-opacity duration-500" style={{
            opacity: fadeState === 'visible' ? 1 : 0,
            minHeight: '120px'
          }} data-id="element-393">
              {headlines[currentHeadline]}
            </h1>
          </div>
          <div className="flex justify-center" data-id="element-394">
            <img src="https://cdn.magicpatterns.com/uploads/uxwsNHVDSHZWPHGHzQBNHB/Eva-Schifferer-Management_Diagnostik-Interview_Training.png" alt="Interviewtraining Stuhl" className="max-h-80 object-contain" data-id="element-395" />
          </div>
        </div>
      </section>

      <section className="w-full text-white py-16 px-6 md:px-12 lg:px-20" style={{
      backgroundColor: '#545454'
    }} data-id="element-396">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-397">
          <div data-id="element-398">
            <p className="mb-6 text-base leading-relaxed" data-id="element-399">
              Die eigenen Führungskräfte und Experten fit zu machen für die
              Durchführung strukturierter Interviews lohnt sich in mehrfacher
              Hinsicht. Manchmal stellt man nach einem Gespräch fest, dass die
              Informationen lückenhaft sind und nicht für eine abschließende
              Einordnung genügen.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-400">
              Abhilfe schafft hier eine professionelle Gesprächsführung, die
              verhaltensbasiert Situation, Handlung und Nutzen erhebt und
              multimodal verschiedene Elemente miteinander kombinieren kann.
            </p>
          </div>
          <div data-id="element-401">
            <p className="mb-6 text-base leading-relaxed" data-id="element-402">
              Themen im Interviewtraining sind die Gesprächstechnik,
              Wahrnehmungs- und Beobachtungsverzerrungen, zuhören können,
              Gesprächssignale deuten und flexibel auf Gesprächssituationen
              reagieren zu können.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-403">
              So stärken Sie die Frage- und Gesprächsführungskompetenz der
              Interviewer, etablieren Vergleichbarkeit in der Organisation und
              erhöhen die Treffsicherheit in der Personalauswahl.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-404">
              Lassen Sie uns darüber sprechen und nehmen Sie Kontakt auf!
            </p>
            <a href="/kontakt" className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 transition-colors" data-id="element-405">
              Lassen Sie uns sprechen
            </a>
          </div>
        </div>
      </section>
    </>;
};